import { useEffect, useState } from 'react'
import { VideoInfoStore } from '@entities/VideoCaptureStore'
import { Heading } from '@ui/Heading'
import { Inline } from '@shared/layout/Inline'
import { observer } from 'mobx-react'
import { WindowAnalyze } from '@entities/video'

export const AIRecommendations = observer(() => {
	const videoCaptureStore: VideoInfoStore = VideoInfoStore.instance
	const recommendations: WindowAnalyze[] = videoCaptureStore.recommendations

	const [currentTime, setCurrentTime] = useState(0)
	const [hasRecommendations, setHasRecommendations] = useState(false)

	useEffect(() => {
		if (recommendations.length > 0 && !hasRecommendations) {
			setHasRecommendations(true)
		}
	}, [recommendations, hasRecommendations])

	useEffect(() => {
		if (!hasRecommendations || !videoCaptureStore.isCaptured) return

		setCurrentTime(0)

		const interval = setInterval(() => {
			setCurrentTime(prevTime => prevTime + 0.1)
		}, 100)

		return () => clearInterval(interval)
	}, [hasRecommendations, videoCaptureStore.isCaptured, videoCaptureStore.replayCounter])

	const filteredRecommendations = recommendations.filter(
		recommendation =>
			currentTime >= recommendation.start_time && currentTime < recommendation.end_time
	)

	return (
		<div
			style={{
				marginTop: 24,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}>
			<Inline align={'center'}>
				<Heading weight={500}>Рекомендации AI</Heading>
			</Inline>
			{videoCaptureStore.isCaptured && (
				<ul style={{ marginTop: 13, width: '100%' }}>
					{filteredRecommendations.map(recommendation => (
						<div
							key={recommendation.window_id}
							style={{
								display: 'flex',
								flexDirection: 'column',
								rowGap: 10,
								marginTop: 10,
							}}>
							{recommendation.messages.map((message, index) => (
								<li key={index}>{message.text}</li>
							))}
						</div>
					))}
				</ul>
			)}
		</div>
	)
})
